<div class="kkm-quarter-view" *transloco="let t; read: 'common.quarters'">
  <div *ngFor="let quarter of quarters; trackBy:quarterIdentity"
       class="kkm-quarter-view__quarter"
       [class.kkm-quarter-view__quarter_active]="isQuarterSelected(quarter)"
       (click)="selectQuarter(quarter)">
    {{ t(quarter.quarter) }}
  </div>
</div>
